export default {
  PromoCode: 'ApplyPromoCode.PromoCode',
};
